import React, { useState } from 'react';
import { Box, Typography, Paper, CircularProgress, Snackbar, Alert } from '@mui/material';
import ReportTopBar from './VehicleReportTopBar';

const VehicleReportsLayout = ({ 
  selectedArea,
  selectedCategory,
  selectedDetection,
  onBackToLive
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleError = (message) => {
    setError(message);
  };

  const handleCloseError = () => {
    setError(null);
  };

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <ReportTopBar
        selectedArea={selectedArea}
        selectedCategory={selectedCategory}
        selectedDetection={selectedDetection}
        onBackToLive={onBackToLive}
      />
      
      {/* Instructions Area */}
      
      {/* Error notification */}
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
      >
        <Alert severity="error" onClose={handleCloseError}>{error}</Alert>
      </Snackbar>
    </Box>
  );
};

export default VehicleReportsLayout;